import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { debounceTime, of, startWith, switchMap } from 'rxjs';
import { Extension } from 'src/app/models/centrex/extension';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { MatSelectionList, MatListOption } from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';

@Component({
    selector: 'app-dialog-add-extensions',
    templateUrl: './dialog-add-extensions.component.html',
    styleUrls: ['./dialog-add-extensions.component.css'],
    imports: [
        MatDialogTitle,
        MatDialogContent,
        MatFormField,
        MatLabel,
        MatInput,
        ReactiveFormsModule,
        MatIconButton,
        MatSuffix,
        MatIcon,
        MatSelectionList,
        MatListOption,
        MatDialogActions,
        MatButton,
        AsyncPipe,
        TranslateModule,
    ]
})
export class DialogAddExtensionsComponent {
    search = new FormControl();
    selectedExtensionsControl = new FormControl([]);
    extensions: Extension[] = [];

    $search = this.search.valueChanges.pipe(
        startWith(null),
        debounceTime(200),
        switchMap((res: string) => {
            if (!res) {
                return of(this.extensions);
            }

            res = res.toLowerCase();

            return of(this.extensions.filter((e) => e.number.toLowerCase().indexOf(res) >= 0 || e.name.toLowerCase().indexOf(res) >= 0));
        })
    );

    constructor(public dialogRef: MatDialogRef<DialogAddExtensionsComponent>, @Inject(MAT_DIALOG_DATA) public data: Extension[]) {
        this.extensions = data;
    }

    selectionChange(option: any) {
        let value = this.selectedExtensionsControl.value;
        if (option[0].selected) {
            value.push(option[0].value);
        } else {
            value = value.filter((x: any) => x != option[0].value);
            this.selectedExtensionsControl.setValue(value);
        }
    }

    close() {
        this.dialogRef.close(null);
    }

    confirm() {
        this.dialogRef.close(this.selectedExtensionsControl.value.length > 0 ? this.selectedExtensionsControl.value : null);
    }

    deleteSearch() {
        this.search.reset();
    }
}
